import { getProperty } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped
import { isError, isLoading } from 'reference-resolvers/utils';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import UITruncateString from 'UIComponents/text/UITruncateString';
// @ts-expect-error untyped
import { TASK_ASSOCIATION_CACHE_KEY } from '../../../reference-resolvers/TaskAssociatedObjectsReferenceResolver';
import { List } from 'immutable';
import hasIn from 'transmute/hasIn';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export function getPropertyTimestampFromRecord(objectRecord, propertyName) {
  return parseInt(getIn(['properties', propertyName, 'timestamp'], objectRecord), 10);
}

/**
 * Returns the associated object with the most recently updated value of propertyName on the object record
 * @param {Object[]} associatedObjects list of { label => String, objectRecord => Record } to iterate through
 * @param {String} propertyName property name to check for updates on
 */

export function getAssociatedObjectWithMostRecentPropertyUpdate(associatedObjects = List(), propertyName) {
  // filter out associations that don't have the given property
  const filteredAssociatedObjects = associatedObjects.filter(hasIn(['objectRecord', 'properties', propertyName]));
  if (filteredAssociatedObjects.size === 0) {
    return null;
  }
  const timestamps = filteredAssociatedObjects.map(associatedObject => {
    const objectRecord = get('objectRecord', associatedObject);
    return getPropertyTimestampFromRecord(objectRecord, propertyName);
  });
  const latestTimestamp = timestamps.max();
  return get(0, filteredAssociatedObjects.filter(associatedObject => {
    const objectRecord = get('objectRecord', associatedObject);
    return getPropertyTimestampFromRecord(objectRecord, propertyName) === latestTimestamp;
  }));
}
export default function makeCellForAssociationTextProperty({
  CellComponent,
  associationCategoryId,
  associationTypeId,
  property
}) {
  const associationTypeKey = `${associationCategoryId}-${associationTypeId}`;
  function AssociationPropertyTextCell({
    resolvedAssociations,
    requiredCellProps
  }) {
    const associatedObjectsData = getIn(['referencedObject', 'associations', associationTypeKey], resolvedAssociations);
    const associatedObjects = get('associatedObjects', associatedObjectsData);
    if (isLoading(resolvedAssociations) || isError(resolvedAssociations) || !associatedObjects) {
      return null;
    }
    const mostRecentlyUpdatedAssociation = getAssociatedObjectWithMostRecentPropertyUpdate(associatedObjects, property);

    // none of the associations have the given property
    if (!mostRecentlyUpdatedAssociation) {
      return null;
    }
    const propertyValue = getProperty(get('objectRecord', mostRecentlyUpdatedAssociation), property);
    if (CellComponent) {
      return /*#__PURE__*/_jsx(CellComponent, {
        value: propertyValue,
        associatedObject: mostRecentlyUpdatedAssociation,
        requiredCellProps: requiredCellProps
      });
    }
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: propertyValue
      })
    });
  }
  const mapResolverToProps = (resolvers, props) => {
    return {
      resolvedAssociations: resolvers[TASK_ASSOCIATION_CACHE_KEY].byId(props.original.objectId)
    };
  };
  const ResolvedAssociationCell = ResolveReferences(mapResolverToProps)(AssociationPropertyTextCell);
  return ResolvedAssociationCell;
}